(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-faq"]) return;
  try {
    
    // Function to toggle section visibility
    function toggleSection(sectionId) {
      const sections = document.querySelectorAll(".sprig-accordion");
      sections.forEach(function(section) {
        if (section.id === sectionId) {
          section.classList.remove("hidden");
          let firstButton = section.querySelector('.sprig-accordion-btn');
          if(firstButton) {
            if(!firstButton.nextElementSibling.classList.contains('active-tab')) {
               firstButton.click();
            } 
          }
          document.body.scrollTop = document.documentElement.scrollTop = 0;
        } else {
          section.classList.add("hidden");
          let firstButton = section.querySelector('.active');
          if(firstButton) {
               firstButton.click();
          }
        }
      });
    }

    // Add event listeners to menu items
    const menuItems = document.querySelectorAll(".menu a");
    let actItem = menuItems[0];
    actItem.classList.add('active')
    menuItems.forEach(function(item) {
      item.addEventListener("click", function(event) {
        event.preventDefault(); // Prevent default link behavior
        console.log(actItem)
        actItem.classList.remove('active')
        actItem = this;
        this.classList.add('active')
        const sectionId = this.getAttribute("href").substring(1); // Get section ID from href
        toggleSection(sectionId);
      });
    });

  document.addEventListener("DOMContentLoaded", function() {
    const questions = document.querySelectorAll(".sprig-accordion-btn");
    if(questions.length) {
      let actTab = questions[0].nextElementSibling;
      questions.forEach(function(question) {
        question.addEventListener("click", function() {
          this.classList.toggle("active");
          const answer = this.nextElementSibling;
          if (answer.style.height === "0px" || !answer.style.height) {
            answer.classList.add('active-tab');
            answer.style.height = answer.scrollHeight + "px";
          } else {
            answer.classList.remove('active-tab');
            answer.style.height = "0px";
          }
          console.log(actTab, answer, answer)
          if(actTab !== answer) {
            actTab.classList.remove('active-tab');
            actTab.style.height = "0px";
            actTab.previousElementSibling.classList.remove('active')
            actTab = answer;
          }
        });
      });
      questions[0].click();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
 document.addEventListener('DOMContentLoaded', function () {
      let selectedColor = ''

      const productItems = document.querySelectorAll('media-gallery .slider__slide');
      // Event listeners for color swatches
      const colorSwatches = document.querySelectorAll('.product-form__input input[type="radio"]');
      colorSwatches.forEach(swatch => {
          swatch.addEventListener('change', function (event) {
              setTimeout(() => {              
                // updateColor(event.target.value);
                const defaultColor = document.querySelectorAll('.product-form__input input[type="radio"]:checked');
                defaultColor.forEach((color, colorIndx) => {
                  let colorX = color;
                    if(color.classList.contains('disabled')) {
                      colorX = color.parentElement.querySelector('input[type="radio"]:not(.disabled)')
                      colorX.nextElementSibling.click();
                    }
                  let totalCount = 0;
                    selectedColor = selectedColor ? selectedColor + '-' + colorX.value : colorX.value;
                    if (colorIndx === defaultColor.length - 1) {
                      productItems.forEach(item => {
                          item.style.display = item.dataset.mediaAlt.toLowerCase().replace(/ /g,'') === selectedColor.toLowerCase().replace(/ /g,'') ? 'block' : 'none';
                          totalCount = item.dataset.mediaAlt.toLowerCase().replace(/ /g,'') === selectedColor.toLowerCase().replace(/ /g,'') ? totalCount + 1 : totalCount;
                        })
                        const sliderCounterTotal = document.querySelector('.slider-counter--total');
                        if(sliderCounterTotal) {
                          if(totalCount)
                          sliderCounterTotal.innerText = totalCount;
                        }
                      let activeThumb = document.querySelector(`.thumbnail-list__item[style="display: block;"] button`);
                        if(activeThumb) {
                          activeThumb.click();
                        }
                          selectedColor = '';
                      }
                    })
              }, 20)
              });
          });

   
        // Initialize with default values if needed
        const defaultColor = document.querySelectorAll('.product-form__input input[type="radio"]:checked'); 
       defaultColor.forEach((color, colorIndx) => {
          selectedColor = selectedColor ? selectedColor + '-' + color.value : color.value;
          if (colorIndx === defaultColor.length - 1) {
            productItems.forEach(item => {
                item.style.display = item.dataset.mediaAlt.toLowerCase().replace(/ /g,'') === selectedColor.toLowerCase().replace(/ /g,'') ? 'block' : 'none';
              })
            let activeThumb = document.querySelector(`.thumbnail-list__item[style="display: block;"] button`);
                        if(activeThumb) {
                          activeThumb.click();
                        }
              selectedColor = '';
            }
          })
        })

  } catch(e) { console.error(e); }
})();
})();
